/**
 * "Manager" for general WebRTC functions.
 * @class WebRTCManager
 */
export default function WebRTCManager (managers) {
  /**
   * Retrieve the list of available and supported codecs based on the browser's capabilities for sending media.
   * @method getAvailableCodecs
   * @param {string} kind The kind of media of which to get the supported codecs of.
   * @return {Array}
   */
  function getAvailableCodecs (kind) {
    return RTCRtpSender.getCapabilities(kind).codecs
  }
  /**
   * The exposed API.
   */
  return {
    getAvailableCodecs
  }
}
